var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExDb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m352 498h-192c-26.508-.983-26.488-39.026 0-40h192c26.508.983 26.488 39.026 0 40zm40-80h-272.021c-66.156 0-119.979-53.822-119.979-119.979v-164.021c0-66.168 53.832-120 120-120h272c66.168 0 120 53.832 120 120v164c0 66.168-53.832 120-120 120zm-272-364c-44.112 0-80 35.888-80 80v164.021c0 44.1 35.879 79.979 79.979 79.979h272.021c44.112 0 80-35.888 80-80v-164c0-44.112-35.888-80-80-80zm248 284h-221c-26.508-.983-26.488-39.026 0-40h221c26.508.983 26.488 39.026 0 40zm-30-70c-11.046 0-20-8.954-20-20v-81c.983-26.508 39.026-26.488 40 0v81c0 11.046-8.954 20-20 20zm-80 0c-11.046 0-20-8.954-20-20v-131c.983-26.508 39.026-26.488 40 0v131c0 11.046-8.954 20-20 20zm-80 0c-11.046 0-20-8.954-20-20v-51c.983-26.508 39.026-26.488 40 0v51c0 11.046-8.954 20-20 20z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExDb);
export default __webpack_public_path__ + "static/media/exDB.e5b8af1fa5fa536bd08690569fc8c46a.svg";
export { ForwardRef as ReactComponent };